export const BUSY_FILLRATE = 77;  // 77..100 - busy
export const FREE_FILLRATE = 33;  // 0..33 - free
export const getItemListLoadingKey = (agency_id, query) => `store/agency_${agency_id}/device/list/requesting?${JSON.stringify(query)}`;
